<p-table
    #dt
    [(selection)]="selectedRows"
    selectionMode="multiple"
    [columns]="listColumns"
    [value]="basketList"
    [paginator]="false"
    responsiveLayout="stack"
    [breakpoint]="'960px'"
    (onRowSelect)="onRowSelect($event)" 
    (onRowUnselect)="onRowUnselect($event)" 
    (onHeaderCheckboxToggle)="onselectAllChange($event)"
    (onSelectionChange)="handleSelectionChange($event)"    
    (onFilter)="onFilter($event)"
    >
    <ng-template let-columns pTemplate="header">
        <tr>
            <th class="width-col-3">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
            @for (col of columns; track col; let i = $index) {
            <th>                    
                <input
                    (click)="$event.stopPropagation()"
                    pInputText
                    type="text"
                    (input)="dt.filter($event.target.value, 'Information.Label', 'contains')"
                    style="color: darkgrey"
                    />
            </th>
            }
        </tr>
    </ng-template>
    <ng-template let-rowData let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData">
            <td (click)="clickcolck($event)">
            <p-tableCheckbox [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
            </td>
            @for (col of columns; track col; let i = $index) {
            <td class="width-auto">
                {{ rowData.Information.Label }}
            </td>
            }
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="7">{{'Empty' | translate}}</td>
        </tr>
    </ng-template>
</p-table>